/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_TitleInputs */

const en_workout_title = /** @type {(inputs: Workout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout`)
};

const pl_workout_title = /** @type {(inputs: Workout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening`)
};

/**
* | output |
* | --- |
* | "Workout" |
*
* @param {Workout_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const workout_title = /** @type {((inputs?: Workout_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_workout_title(inputs)
	return en_workout_title(inputs)
});